module.exports = __webpack_public_path__ + "src/img/kaoping.40709ee4.svg";